import React from 'react';
import { ExternalLink, Headphones } from 'lucide-react';

export const SPOTIFY_BIBLE_TALKS = 'https://open.spotify.com/show/7tGp8iEuMfw3n08lxiydRp';
export const SPOTIFY_WORSHIP_PLAYLIST = 'https://open.spotify.com/playlist/1L0INgkjUbDF6iRjTB73Ym';

export const SpotifyLinkCard = ({ href, title, subtitle, testId, className = '' }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`group flex items-center gap-4 rounded-2xl bg-[#121212] px-5 py-4 text-white shadow-md transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-lg ${className}`}
  >
    <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-[#1DB954] transition-transform duration-200 group-hover:scale-105">
      <Headphones className="h-6 w-6 text-black" />
    </div>
    <div className="min-w-0 flex-1">
      <p className="text-[11px] font-semibold uppercase tracking-widest text-[#1DB954]">Listen on Spotify</p>
      <p className="truncate font-semibold">{title}</p>
      {subtitle && <p className="truncate text-sm text-white/60">{subtitle}</p>}
    </div>
    <ExternalLink className="h-4 w-4 flex-shrink-0 text-white/50 transition-colors group-hover:text-white" />
  </a>
);
